import { SEMI_MONTHLY } from 'helpers/Constants';

const displayPropsRules = {
  referralSubtext: [
    {
      logic: 'eval',
      targets: ['fieldsToDisplay.referralSubtext'],
      property: 'isReferral',
      operator: 'equal',
      triggerValue: 'true',
      resultValue: true,
      resetValue: false
    }
  ],
  primaryIncomeSource: [
    {
      logic: 'eval',
      targets: ['additionalProps.nameOfIncome.label'],
      property: 'primaryIncomeSource',
      operator: 'contain',
      triggerValue: ['employment', 'self_employed'],
      resultValue: 'Name of Employer',
      resetValue: 'Name of Income Source'
    },
    {
      logic: 'eval',
      targets: ['additionalProps.lengthOfReceivingIncome.label'],
      property: 'primaryIncomeSource',
      operator: 'contain',
      triggerValue: ['employment', 'self_employed'],
      resultValue: 'Length of Employment',
      resetValue: 'Length of Receiving Income'
    }
  ],
  productOwner: [
    {
      logic: 'eval',
      targets: ['fieldsToDisplay.occupation'],
      property: 'productOwner',
      operator: 'equal',
      triggerValue: 'ccb',
      resultValue: true,
      resetValue: false
    }
  ],
  lastPayrollMinDate: [
    {
      logic: 'eval',
      targets: ['additionalProps.lastPayrollDate.minDate'],
      property: 'paymentFrequency',
      operator: 'equal',
      triggerValue: SEMI_MONTHLY,
      resultValue: -18,
      resetValue: -40
    }
  ],
  nextPayrollDate: [
    {
      logic: 'and',
      targets: [
        'fieldsToDisplay.nextPayrollDate',
        'fieldsToDisplay.nextPayrollDateTitle'
      ],
      resultValue: true,
      resetValue: false,
      rule: [
        {
          logic: 'eval',
          property: 'paymentFrequency',
          operator: 'equal',
          triggerValue: SEMI_MONTHLY
        },
        {
          property: 'lastPayrollDate',
          logic: 'eval',
          operator: 'exist'
        }
      ]
    }
  ]
};

export default displayPropsRules;
